module.exports = "/static/media/dtmf-star.532480f2.mp3";